<template>
  <div>
    <b-table striped hover :fields="fields" :items="printers">
      <template slot="actions" slot-scope="cell">
        <b-button-group vertical>
          <b-button
            size="sm"
            class="align-top"
            variant="outline-secondary"
            :to="{ name: 'EditPrinter', params: { id: cell.item.id } }"
          >
            <icon name="edit" class="align-middle"></icon>
          </b-button>
        </b-button-group>
      </template>
    </b-table>
  </div>
</template>

<script>
import Notify from "@/notify";

export default {
  mixins: [Notify],
  props: ["printers"],
  data() {
    return {
      fields: ["description", "ticket_type", "actions"],
    };
  },
};
</script>

<style></style>



// WEBPACK FOOTER //
// src/components/printers/PrintersList.vue